import { render, staticRenderFns } from "./serviceFeeForm.vue?vue&type=template&id=533cc5c0&scoped=true"
import script from "./serviceFeeForm.vue?vue&type=script&lang=js"
export * from "./serviceFeeForm.vue?vue&type=script&lang=js"
import style0 from "./serviceFeeForm.vue?vue&type=style&index=0&id=533cc5c0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533cc5c0",
  null
  
)

export default component.exports